// extracted by mini-css-extract-plugin
export default {"title":"TeamAcceptHeading_title__QLhgr","lead":"TeamAcceptHeading_lead__G3QG2"};